const env = import.meta.env;

const parsePort = (value, fallback) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback;
};

export const runtimeConfig = Object.freeze({
  mode: env.MODE,
  baseUrl: env.BASE_URL,
  isProduction: env.PROD,
  firebase: Object.freeze({
    apiKey: env.VITE_FIREBASE_API_KEY || '',
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || '',
    projectId: env.VITE_FIREBASE_PROJECT_ID || '',
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: env.VITE_FIREBASE_APP_ID || '',
    measurementId: env.VITE_FIREBASE_MEASUREMENT_ID || '',
    appCheckSiteKey: env.VITE_FIREBASE_APP_CHECK_SITE_KEY || '',
    appCheckProvider: env.VITE_FIREBASE_APP_CHECK_PROVIDER || 'recaptcha-v3',
    appCheckDebugToken: env.VITE_FIREBASE_APP_CHECK_DEBUG_TOKEN || '',
    emulatorMode: env.VITE_USE_FIREBASE_EMULATORS || 'auto',
    firestoreHost: env.VITE_FIRESTORE_EMULATOR_HOST || '',
    firestorePort: parsePort(env.VITE_FIRESTORE_EMULATOR_PORT, 8080),
    authEmulatorHost: env.VITE_FIREBASE_AUTH_EMULATOR_HOST || '',
    functionsPort: parsePort(env.VITE_FIREBASE_FUNCTIONS_EMULATOR_PORT, 5001),
    emulatorUiUrl: env.VITE_FIREBASE_EMULATOR_UI_URL || 'http://127.0.0.1:4000',
  }),
});

const fallbackBuildInfo = {
  version: 'dev',
  commit: 'local',
  buildTime: null,
};

export const buildInfo = Object.freeze(
  typeof __APP_BUILD_INFO__ === 'undefined' ? fallbackBuildInfo : __APP_BUILD_INFO__
);

export default runtimeConfig;
